import styled from '@emotion/styled';
import { Tooltip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import {
  Grid,
  TableHeaderRow,
  VirtualTable,
  VirtualTableProps,
} from '@devexpress/dx-react-grid-material-ui';
import { useDataGridFlexSales } from '../DataGridFlexSalesProvider';

/* 
  Estas constantes son necesarias para poder utilizar VirtualTable. 
  Si no matchean al scrollear se va visualizar mal.
  Al cambiar CELL_PADDING hay que ver que valor toma el alto de la fila (para establecer ESTIMATED_ROW_HEIGHT).
  Como ESTIMATED_ROW_HEIGHT toma valores en px, el padding (CellStyled y GridHeaderCell) tambien se estableció en px
*/
const CELL_PADDING = 7;
export const ESTIMATED_ROW_HEIGHT = 35;

export const GridRootStyled = styled(Grid.Root)`
  width: 100%;
  height: 100%;
`;

export const VirtualTableCellStyled = styled(VirtualTable.Cell)`
  padding: 0;
  overflow: visible !important;
  height: ${ESTIMATED_ROW_HEIGHT}px;
  color: ${({ theme }) => theme.palette.text.primary};
  *:first-of-type {
    vertical-align: middle;
  }
`;

const CellDataContainer = styled.div`
  height: ${ESTIMATED_ROW_HEIGHT - 1}px;
  vertical-align: middle;
  padding: ${CELL_PADDING}px;
  display: inline-block;
  box-sizing: border-box;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  border-radius: 8px;
`;

const CellTooltip = styled(Tooltip)`
  cursor: help;
`;

export const VirtualTableCell: VirtualTableProps['cellComponent'] = ({ column, row, ...rest }) => {
  const { handler } = useDataGridFlexSales();
  const col = handler.getColumnById(column.name);
  return (
    <VirtualTableCellStyled column={column} row={row} {...rest}>
      <CellDataContainer>{col.getCell(row.ORIGINAL_ITEM)}</CellDataContainer>
    </VirtualTableCellStyled>
  );
};

export const TableHeaderRowCell = styled(TableHeaderRow.Cell)`
  padding: ${CELL_PADDING + 3}px ${CELL_PADDING}px;
  color: ${({ theme }) => theme.palette.text.primary};
  font-weight: ${({ theme }) => theme.typography.subtitle2.fontWeight};
  background-color: ${({ theme }) => alpha(theme.palette.background.paper, 0.86)};
  backdrop-filter: blur(8px);

  span.ResizingControl-sortLabelRoot {
    color: inherit;
    svg.MuiTableSortLabel-icon {
      color: inherit;
    }
  }

  span.ResizingControl-sortLabelRoot:hover {
    color: ${({ theme }) =>
      theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.primary.main};
  }
`;

export const VirtualTableHeaderCell = ({ column, children, ...rest }: TableHeaderRow.CellProps) => {
  const { handler } = useDataGridFlexSales();
  const col = handler.getColumnById(column.name);
  return (
    <TableHeaderRowCell column={column} {...rest}>
      {col.getTooltip() ? (
        <CellTooltip title={col.getTooltip()} placement="left-start" arrow>
          <div>{children}</div>
        </CellTooltip>
      ) : (
        children
      )}
    </TableHeaderRowCell>
  );
};
